import './WebChatPluginButton.scss';
import IconButton from '@mui/material/IconButton';
import ChatIcon from '@mui/icons-material/Chat';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';

export function WebChatPluginButton({
  onClick,
  webChatConfiguration,
  hideTooltip,
}) {
  return (
    <div className="prospera-web-chat-plugin-button">
      <Tooltip
        open={!hideTooltip && webChatConfiguration?.show_chat_button_callout}
        title={webChatConfiguration.chat_button_callout_text}
        placement={'top-start'}
        classes={{ tooltip: 'prospera-web-chat-button-tooltip' }}
      >
        <IconButton
          aria-label="chat-with-bot"
          style={{
            width: 64,
            height: 64,
            backgroundColor:
              webChatConfiguration?.chat_button_color || '#0041ed',
          }}
          onClick={onClick}
        >
          {
            webChatConfiguration?.chat_button_icon_image_url ? (
              <img
                src={webChatConfiguration?.chat_button_icon_image_url}
                alt={webChatConfiguration?.chat_button_callout_text || "Chat with the Bot"}
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                }}
              />
            ) : (
              <ChatIcon fontSize="inherit" sx={{ fontSize: 32 }} />
            )
          }
          <div className={'hover-overlay'}></div>
        </IconButton>
      </Tooltip>
    </div>
  );
}
